import { OpdRemainTextProps } from './type'
import { Container, Counter, Label } from './style'

export default function OpdRemainText({ count }: OpdRemainTextProps) {
  return (
    <Container>
      <Label>จำนวนครั้งคงเหลือของ OPD</Label>
      <Counter>{count || 'N/A'}</Counter>
    </Container>
  )
}
